/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';
export const DEFAULT_LOCALE = 'it';



// WEBPACK FOOTER //
// ./app/containers/LanguageProvider/constants.js